export default __webpack_public_path__ + "static/media/G89A7277-2.36955ba6.jpg";